import styled from 'styled-components';
import { Modal, Button } from '@prosolve/common-components-ui'

const Content = styled.div`
  flex: 1;
  flex-direction: column;
  // padding: 16px;
  display: flex;
  flex-direction: column;
  // row-gap: 16px;
  color: #565656;
  /* width: 400px; */
  font-weight: normal;
  font-family: "PassionOne-Regular", "Open Sans", sans-serif;
  position: relative;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  color: #565656;
  font-weight: normal;
  font-family: "PassionOne-Regular", "Open Sans", sans-serif;
`

const Title = styled.div`
  font-size: 32px;
`

const BreakdownBlockContainer = styled.div`
  display: flex;
  border: 1px solid #c4c4c4;
  border-radius: 10px;
  margin-bottom: 5px;
  padding: 5px 10px;
  font-size: 24px;
`

const ScoreKey = styled.div`
  display: flex;
`

const Seperator = styled.div`
  flex: 1;
`

const ScoreValue = styled.div`
  display: flex;
`

const EvidenceBlockContainer = styled.div`
  display: flex;
  border: 1px solid #c4c4c4;
  border-radius: 10px;
  margin-bottom: 5px;
  padding: 10px 10px;
`

const EvidenceSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

const EvidenceSectionBlock = styled.div`
  display: flex;
  flex-direction: column;
`

const EvidenceSectionBlockTitle = styled.div`
  /* margin-top: 10px; */
  margin-bottom: 5px;
  font-size: 24px;
`

const EvidenceSectionBlockValue = styled.div`
  color: #565656;
  margin-bottom: 5px;
  font-size: 18px;
`

const EvidenceScoreValue = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;
  font-size: 18px;
`

// const ButtonsContainer = styled.div`
//   display: flex;
//   justify-content: flex-end;
//   align-items: center;
//   column-gap: 10px;
//   padding: 10px;
// `

export default ({
  data = {},
  onClose,
}) => {
  const {
    strand_name = '',
    ipStrands = []
  } = data;

  const strandNameUrlMap = {
    'Analysis': 'https://api.go.prosolve.com/api/file/pdExperienceThumbnails/analysis-strand-rubric.png',
    'Expression': 'https://api.go.prosolve.com/api/file/pdExperienceThumbnails/expression-strand-rubric.png',
    'Listening': 'https://api.go.prosolve.com/api/file/pdExperienceThumbnails/listening-strand-rubric.png',
    'Advancing': 'https://api.go.prosolve.com/api/file/pdExperienceThumbnails/advancing-strand-rubric.png',
    'Contribution': 'https://api.go.prosolve.com/api/file/pdExperienceThumbnails/contribution-strand-rubric.png',
    'Imagination': 'https://api.go.prosolve.com/api/file/pdExperienceThumbnails/imagination-strand-rubric.png'
  }

  const allInstances = []
  const scoreMap = { '1': 0, '2': 0, '3': 0, '4': 0}

  ipStrands.forEach(({ score_distribution = {}, instances = [] }) => {
    Object.keys(score_distribution).forEach(key => {
      const val = score_distribution[key]
      scoreMap[key] += val;
    });
    allInstances.push(...instances);
  });

  const TitleComponent = (
    <Header>
      {/* <FaExclamationTriangle style={{ color: '#F88700', marginRight: '10px', fontSize: '22px' }} /> */}
      <Title>
        {'Score Breakdown and Evidence'}
      </Title>
    </Header>
  )

  // const baseButtonStyle = {
  //   padding: '10px',
  //   fontSize: '18px',
  //   borderRadius: '10px',
  //   fontFamily: '"PassionOne-Regular", "Open Sans", sans-serif'
  // }

  // const FooterComponent = (
  //   <ButtonsContainer>
  //     <Button style={baseButtonStyle} $colored={true} onClick={onClose}>
  //       {'Close'}
  //     </Button>
  //     {/* <Button style={{ ...baseButtonStyle, fontWeight: 'bold' }} onClick={onPracticeEpisodeConfirmation} $colored={true}>
  //       {'PROCEED WITHOUT SAVING'}
  //     </Button> */}
  //   </ButtonsContainer>
  // )
  
  const Breakdown = ({
    score,
    value,
    style = {}
  }) => {
    return (
      <BreakdownBlockContainer style={style}>
        <ScoreKey>{score}</ScoreKey>
        <Seperator>&nbsp;</Seperator>
        <ScoreValue>{value}</ScoreValue>
      </BreakdownBlockContainer>
    )
  }

  const Evidence = ({
    evidence,
    reasoning,
    score
  }) => {

    let eStyle = {};
    if (score === 4) {
      eStyle = { background: '#D5E8D4', color: '#60A918'}
    } else if (score === 3) {
      eStyle = { background: '#DAE8FC', color: '#0050EF'}
    } else if (score === 2) {
      eStyle = { background: '#FFE6CC', color: '#F0A30A'}
    } else if (score === 1) {
      eStyle = { background: '#F8CECC', color: '#FA6800'}
    }

    const scoreMap = {
      '4': 'Advanced',
      '3': 'Proficient',
      '2': 'Beginning',
      '1': 'Developing'
    }

    return (
      <EvidenceBlockContainer style={eStyle}>
        <EvidenceSection>
          <EvidenceSectionBlock style={{ borderBottom: '1px solid #c4c4c4', marginBottom: '10px'}}>
            <EvidenceSectionBlockTitle>{'Transcript'}</EvidenceSectionBlockTitle>
            <EvidenceSectionBlockValue>{evidence}</EvidenceSectionBlockValue>
          </EvidenceSectionBlock>
          <EvidenceSectionBlock>
            <EvidenceSectionBlockTitle>{'Analysis'}</EvidenceSectionBlockTitle>
            <EvidenceSectionBlockValue>{reasoning}</EvidenceSectionBlockValue>
          </EvidenceSectionBlock>
        </EvidenceSection>
        <EvidenceScoreValue>{scoreMap[score] || '-'}</EvidenceScoreValue>
      </EvidenceBlockContainer>
    )
  }

  const onOpenRubric = () => {
    const url = strandNameUrlMap[strand_name]
    window.open(url,'_blank')
  }

  return (
    <Modal title={TitleComponent} isFullScreen={false} isAutoHeight={true} isAutoWidth={false} closeOnOffClick={true} onClose={onClose}>
      <Content>
        <div
          style={{
            position: 'absolute',
            top: '0px',
            right: '0px'
          }}
        >
          <Button
            style={{ background: 'transparent', color: '#565656' }}
            $colored={true}
            onClick={onOpenRubric}
          >
            {'View Rubric'}
          </Button>
        </div>
        <Title style={{ marginBottom: '10px' }}>
          {'Score Breakdown'}
        </Title>
        <Breakdown score={'Advanced'} value={scoreMap['4']} style={{ background: '#D5E8D4', color: '#60A918'}} />
        <Breakdown score={'Proficient'} value={scoreMap['3']} style={{ background: '#DAE8FC', color: '#0050EF'}} />
        <Breakdown score={'Beginning'} value={scoreMap['2']} style={{ background: '#FFE6CC', color: '#F0A30A'}} />
        <Breakdown score={'Developing'} value={scoreMap['1']} style={{ background: '#F8CECC', color: '#FA6800'}} />
        <Title style={{ marginTop: '15px',  marginBottom: '10px' }}>
          {'Evidence'}
        </Title>
        {
          allInstances.map(({ evidence, reasoning, score }, index) => {
            return (
              <Evidence
                key={index}
                evidence={evidence}
                reasoning={reasoning}
                score={score}
              />
            )
          })
        }
      </Content>
    </Modal>
  )
}